import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipDirective, TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'tmx-inline-help',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './inline-help.component.html',
  styleUrls: ['./inline-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineHelpComponent {
  @Input() summary = '';
  @Input() description = '';
  @Input() placement: 'auto' | 'bottom' | 'left' | 'right' | 'top' = 'auto';
  isFocused = false;

  toggle(tooltip: TooltipDirective) {
    if (!this.isFocused) {
      this.isFocused = true;
      tooltip.show();
      return;
    }

    tooltip.toggle();
  }
}
